const Message = ({styles, message}) => {
  return <span className={styles.message}>{message}</span>;
}

export default Message;